import { ChakraProvider } from "@chakra-ui/react";
import { Web3ReactProvider } from "@web3-react/core";
import { HashRouter as Router, Route } from "react-router-dom";
import MainLayout from "./layouts/main";
import Home from "./views/home";
import Punks from "./views/punks";
import Punk from "./views/punk";
import { getLibrary } from "./config/web3";

const App = () => {
  return (
    <Router>
      <ChakraProvider>
        <Web3ReactProvider getLibrary={getLibrary}>
          <MainLayout>
            <Route path="/" exact component={Home} />
            <Route path="/punks" exact component={Punks} />
            <Route path="/punks/:tokenId" component={Punk} />
          </MainLayout>
        </Web3ReactProvider>
      </ChakraProvider>
    </Router>
  );
};

export default App;
